<script>
/** Components */
import FinanceBulkExpenditures from "@/components/widgets/template-bulk-expenditures.vue";
import DeliveryUnitBudgetItem from "@/components/tables/template-deliveryUnit-budgetItem.vue";
import RawData from "@/components/widgets/raw-data.vue";
import { groupBy } from "lodash";
export default {
  props: {
    deliveryUnits: {},
    template: {
      type: Number,
    },
    load: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    FinanceBulkExpenditures,
    DeliveryUnitBudgetItem,
    RawData
  },
  data() {
    return {
      availableAccountsConsist: "LEAF_PRIORITY",
      fields: [
        {
          key: "details",
          label: " ",
          thClass: { width: "15px" },
        },
        {
          key: "name",
          label: "Delivery Unit",
          sortable: true,
        },
        {
          key: "office",
          label: "Office",
          sortable: true,
        },
        {
          key: "totalAllocated",
          sortable: true,
          tdClass: "text-right",
          thClass: "text-right",
        },
        {
          key: "totalUsed",
          sortable: true,
          tdClass: "text-right",
          thClass: "text-right",
        },
        {
          key: "remaining",
          sortable: true,
          tdClass: "text-right",
          thClass: "text-right",
        },
        {
          key: "action",
          label: " ",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: "",
      filterOn: ['name'],
      prexcs: [],
      expenditureTable: [],
      newData: [],
      availableAccounts: [],
      selectedPrexc: null,
      sortDesc: false,
      tableBusy: false,
      bulkBudgetModal: false,
      accountsModal: false,
      selectedDeliveryUnit: {},
    };
  },
  computed: {
    rows() {
      if (this.filter.trim() != "" && this.filter) {
          let data = this.deliveryUnits;
          data = data.filter((item) => {
              return item.name
                  .toUpperCase()
                  .includes(this.filter.toUpperCase());
          });
          return data.length;
      }
      return this.deliveryUnits.length;
    },
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    formatCurrency(data) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "PHP",
      }).format(data);
    },
    viewDetails(row) {
      this.selectedDeliveryUnit = row;
      this.bulkBudgetModal = true;
      this.viewAccounts()
    },
    fetchPrexcs() {
      this.$store
        .dispatch("prexc/GetPrexc")
        .then((response) => {
          if (response.data.error) {
            return this.showToast(response.data.errorMessage, "error");
          }
          let sample = response.data.map((item) => ({
            value: item.id,
            text: item.prexcName,
          }));
          this.prexcs = sample.sort((a, b) => a.text.localeCompare(b.text));
          this.prexcs.unshift({
            value: null,
            disabled: true,
            text: "Please select PREXC...",
          });
          this.tableBusy = false;
        })
        .catch((error) => {
          this.showToast("Error getting prexc listing", "error");
        });
    },
    saveBulk() {
      const items = JSON.parse(JSON.stringify(this.availableAccounts));
      let newItems = [];
      items.map((item) => {
        item.items.map((x) => {
        console.log(x.amount && !isNaN(x.amount));
          if (x.amount && x.amount.trim() !== "") {
            newItems.push({
              financeTemplateObjectOfExpenditureId: x.id,
              allowAdd: item.allowAdd,
              allowTransfer: x.allowTransfer,
              deliveryUnitId: this.selectedDeliveryUnit.id,
              amount: this.getExactAmt(x.amount),
            });
          }
        }); 
      });
      this.$store
        .dispatch("financeTemplate/createMultipleBudgetItem", newItems)
        .then(async (response) => {
          if (response.data.error) {
            this.showToast(response.data.errorMessage, "error");
            return;
          }
          this.availableAccounts = [];
          this.bulkBudgetModal = false;
          this.selectedDeliveryUnit.isLoadingDetails = true;
          await this.fetchDeliveryUnit(this.selectedDeliveryUnit.id);
          this.selectedDeliveryUnit.isLoadingDetails = false;
          this.$emit("update", this.selectedDeliveryUnit.id);
          this.$emit("updateTemplate", this.template);
          this.showToast("Budget items successfully created", "success");
        })
        .catch((error) => {
          this.pageLoader(false);
          this.showToast("Error saving bulk budget", "error");
        });
    },
    async showDtls(row) {
      row.toggleDetails();
      row.item.showDetails = !row.item.showDetails;
      if (row.item.showDetails) {
        row.item.isLoadingDetails = true;
        await this.fetchDeliveryUnit(row.item.id);
        row.item.isLoadingDetails = false;
      } 
    },
    async fetchDeliveryUnit(id) {
      this.$store.commit("financeTemplate/setIsOfficeBudgetLoading", true);
      await this.$store
        .dispatch(
          "financeTemplate/getTemplateBudgetItemByDeliveryUnitAndTemplateId",
          {
            financeTemplateId: this.template,
            deliveryUnitId: id,
          }
        )
        .then((response) => {
          this.deliveryUnits.find(
            (item) => item.id === id
          ).officeBudget = response.data.map((item) => ({
            ...item,
            rotateChevy: false,
            forEdit: false,
            accountGroup: item.financeTemplateObjectOfExpenditure.accountGroup.groupName,
            budgetItems: [],
            isBudgetItemLoading: false,
            amountString: item.amount.toString(),
            fundClass: item.financeTemplateObjectOfExpenditure.accountGroup.fundClassification.classification,
          }));
        })
        .catch((error) => {
          this.showToast("Error fetching budget", "error");
        });
    },
    viewAccounts() {
      this.$store
        .dispatch("financeTemplate/getAvailableAccountsByDU", {
          financeTemplateId: this.template,
          duId: this.selectedDeliveryUnit.id,
        })
        .then((res) => {
          if(res.data.error){
            return this.showToast(res.data.errorMessage, 'error')
          }
          res.data.map(item => {
            item.allowTransfer = false;
            item.allowAdd = false;
            item.amount = "";
            item.filterKey = `${item.accountGroup.fundClassification.classification} ${item.accountGroup.groupName}`;
            item.fundClass = item.accountGroup.fundClassification.classification;
          })
          let grpData = [];
          let grp = groupBy(res.data, "fundClass");
          Object.entries(grp).map(([key, value]) => {
            let filterKey = key;
            let accountGrps = groupBy(value, "accountGroup.id");
            let accGrps = [];
            Object.entries(accountGrps).map(([gkey, gvalue]) => {
              accGrps.push(accountGrps[gkey][0]);
              filterKey += ` ${accountGrps[gkey][0].accountGroup.groupName}`;
            });
            let obj = {
              fundClassName: key,
              id: value[0].accountGroup.fundClassification.id,
              filterKey: filterKey,
              items: accGrps,
              allowAdd: false,
              showAdd: false,
            };
            grpData.push(obj);
          });
          this.availableAccounts = grpData;
          this.$store.commit(
            "financeTemplate/setIsAvailableAccountsLoading",
            false
          );
        })
        .catch((e) => {
          this.$store.commit(
            "financeTemplate/setIsAvailableAccountsLoading",
            false
          );
          this.showToast(
            "Something went wrong. Cannot fetch available PREXCs",
            "error"
          );
        });
    },
    removeOB(id) {
      const index = this.expenditureTable.findIndex((item) => item.id === id);
      this.expenditureTable.splice(index, 1);

      this.$emit("updateTemplate", this.template);
    },
    removeAll() {
      this.expenditureTable = [];
    },
    async updateOB(data) {
      await this.fetchDeliveryUnit(data.deliveryUnitId);
      this.$emit("update", data.deliveryUnitId);
      this.$emit("updateTemplate", this.template);
    },
    toggleEdit(data) {
      data.forEdit = !data.forEdit;
    },
    printLIB(data) {
      this.$emit("lib", data);
    },
    printOPCR(data) {
      this.$emit("opcr", data);
    },
    printPPMP(data) {
      this.$emit("ppmp", data);
    },
  },
  created() {
    this.fetchPrexcs();
  },
};
</script>

<template>
  <div
    id="datatable_wrapper"
    class="dataTables_wrapper dt-bootstrap4 no-footer"
  >
    <div class="row">
      <div class="col-md-12 d-flex flex-row-reverse">
        <div id="tickets-table_length" class="dataTables_length">
          <label class="d-inline-flex align-items-center mb-0">
            <b-form-select
              class="form-select"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
            >
            </b-form-select>
          </label>
        </div>
        <div id="tickets-table_filter" class="dataTables_filter me-1">
          <label class="d-inline-flex align-items-center">
            <b-form-input
              autocomplete="off"
              v-model="filter"
              type="search"
              placeholder="Search Delivery Unit..."
              class="form-control"
            ></b-form-input>
          </label>
        </div>
      </div>
    </div>
    <div class="row">
      <!-- table data -->
      <div class="col-lg-12">
        <div class="table-responsive mb-0">
          <b-table
            class=""
            :items="deliveryUnits"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
            :sort-desc.sync="sortDesc"
            :filter="filter"
            :filter-included-fields="filterOn"
            :busy="load"
            @filtered="onFiltered"
            show-empty
          >
            <template #empty="scope">
              <div class="text-center">
                <h5 class="text-secondary">{{ scope.emptyText }}</h5>
              </div>
            </template>
            <template #table-busy>
              <div class="d-flex justify-content-center align-items-center">
                <div class="preloader-component me-2">
                  <div class="status">
                    <div class="spinner-chase w-20px h-20px">
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                    </div>
                  </div>
                </div>
                <strong>Loading...</strong>
              </div>
            </template>
            <template #cell(name)="row">
              <span class="position-relative">
                <RawData :data="row.item" v-if="$store.state.decrypt.isAdmin()"/>
                {{ row.item.name }}
              </span>
            </template>
            <template #cell(totalAllocated)="row">
              <span class="text-info">
                {{ formatCurrency(row.item.totalAllocated) }}
              </span>
            </template>
            <template #cell(totalUsed)="row">
              <span class="text-success">
                {{ formatCurrency(row.item.totalUsed) }}
              </span>
            </template>
            <template #cell(remaining)="row">
              <span class="text-warning">
                {{ formatCurrency(row.item.remaining) }}
              </span>
            </template>
            <template #row-details="row">
              <div
                v-if="row.item.isLoadingDetails"
                class="my-3 d-flex align-items-center justify-content-center mt-3"
              >
                <div class="preloader-component me-2">
                  <div class="status">
                    <div class="spinner-chase w-25px h-25px">
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                    </div>
                  </div>
                </div>
                <h5 class="mb-0">Loading...</h5>
              </div>
              <DeliveryUnitBudgetItem
                ref="deliveryUnitBudgetItem"
                :deliveryUnit="row.item.id"
                :rowItem="row.item"
                :budgetline="row.item.officeBudget"
                @updateList="updateOB"
                @toggleEdit="toggleEdit"
                @lib="printLIB"
                @opcr="printOPCR"
                @ppmp="printPPMP"
                @updateOfficeBudget="fetchDeliveryUnit"
                @viewDetails="viewDetails"
                v-else
              />
            </template>
            <template #cell(details)="row">
              <a href="javascript:void(0)" role="button" @click="showDtls(row)">
                <i
                  class="bx bx-chevron-right rotate font-size-16 cursor-pointer align-middle"
                  :class="{
                    'rotate-90': row.item.showDetails,
                  }"
                ></i>
                <!-- <i :class="{
                                                                            'mdi mdi-eye-outline text-info': !row.item.showDetails,
                                                                            'mdi mdi-eye-off-outline text-danger': row.item.showDetails,
                                                                          }"></i> -->
              </a>
            </template>
          </b-table>
        </div>
      </div>
      <!-- table data -->
    </div>
    <div class="row mb-2 mt-1">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-end">
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>
    <!-- Bulk Budget Expenditures -->
    <b-modal
      v-model="bulkBudgetModal"
      title="Add Bulk Budget Line Item"
      size="xl"
      title-class="font-18"
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
    >
      <div class="row">
        <div class="col-md-6">
          <small class="d-block">Delivery Unit: </small>
          <h5 class="text-info mb-0" v-if="selectedDeliveryUnit">
            {{ selectedDeliveryUnit.name }}
          </h5>
        </div>
        <div class="col-md-6">
          <small class="d-block">Office: </small>
          <h5
            class="text-info mb-0"
            v-if="selectedDeliveryUnit && selectedDeliveryUnit.office"
          >
            {{ selectedDeliveryUnit.office.name }}
          </h5>
        </div>
      </div>
      <hr />

      <div class="mb-3">
        <FinanceBulkExpenditures
          :items="availableAccounts"
          @deleteOB="removeOB"
          @removeAll="removeAll"
        />
      </div>
      <div class="modal-footer">
        <b-button variant="primary" @click="saveBulk">Save</b-button>
        <b-button variant="link" @click="bulkBudgetModal = !bulkBudgetModal"
          >Close</b-button
        >
      </div>
    </b-modal>
  </div>
</template>
